import { getLocalizedName } from '../../lib/localization'
import type { components } from '../../api/schema'

type DocumentType = components['schemas']['DocumentType']

/**
 * Display helpers for the folder-layout editor.
 *
 * They live in their own module (rather than inside the editor component) for
 * two reasons: they are pure, so they can be unit-tested without a DOM, and
 * both the route and the detail pane consume them.
 *
 * The `locale` is threaded in as a **parameter** on purpose — these run inside
 * `useMemo`s, where calling a hook is illegal. Callers read it once via
 * `useLocale()` and must list it in the memo dependency array so a language
 * switch re-labels the UI immediately.
 */
export function folderDisplayName(
    folder: { name?: { [key: string]: string } | null },
    locale: string
): string {
    return getLocalizedName(folder.name, locale) || 'Unnamed'
}

export function documentTypeDisplayName(dt: DocumentType, locale: string): string {
    // Older payloads (and some embedded shapes) carry a plain string name.
    if (typeof dt.name === 'object' && dt.name !== null) {
        return getLocalizedName(dt.name as { [key: string]: string }, locale) || dt.code
    }
    return dt.name || dt.code
}
